import { EditorView } from '@codemirror/view';
export var defaultLightThemeOption = EditorView.theme({
  '&': {
    backgroundColor: '#fff'
  }
}, {
  dark: false
});